import styled from 'styled-components'

export const Header = styled.h4`
  display: block;
  width: 100%;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  border-bottom: 1px solid ${props => props.theme.colors.secondaryLight};
  text-transform: uppercase;
`



// WEBPACK FOOTER //
// ./src/components/CollectionWithHeader/theme.js